
export enum MediaType {
  UNKNOWN = -1,
  PICTURE = 1,
  REPORT,
  VIDEO,
  AUDIO,
}
